import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, resolveImage } from '@/lib/api';
import { ArrowRight, BookOpen } from 'lucide-react';
import SEO from '@/components/dubinko/SEO';

export default function SavetiPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blog').then(({ data }) => setPosts(data)).finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="saveti-index">
      <SEO
        title="Saveti za čišćenje i održavanje doma"
        description="Korisni saveti o dubinskom čišćenju, pranju tepiha, održavanju doma i čišćenju nakon renoviranja — od Dubinko tima iz Niša."
        path="/saveti"
      />
      <section className="section-pad aurora-bg grain">
        <div className="container-x">
          <span className="tag-pill"><BookOpen className="w-3.5 h-3.5" /> Saveti & blog</span>
          <h1 className="font-display text-5xl md:text-6xl font-extrabold mt-4 max-w-3xl">
            Saveti za čist i zdrav dom
          </h1>
          <p className="text-slate-600 mt-4 text-lg max-w-2xl">
            Praktični vodiči i saveti našeg tima — kako da vaš prostor uvek izgleda i miriše besprekorno.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x">
          {loading ? (
            <div className="text-slate-500">Učitavanje…</div>
          ) : posts.length === 0 ? (
            <div className="text-slate-500">Uskoro objavljujemo prve savete.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link key={p.id} to={`/saveti/${p.slug}`} data-testid="blog-card"
                  className="group bg-white border border-slate-200 rounded-3xl overflow-hidden hover:shadow-lg transition flex flex-col">
                  {p.cover_image && (
                    <div className="overflow-hidden aspect-[16/10]">
                      <img src={resolveImage(p.cover_image)} alt={p.title} loading="lazy" decoding="async"
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                  )}
                  <div className="p-6 flex flex-col flex-1">
                    <h2 className="font-display text-xl font-bold leading-snug">{p.title}</h2>
                    <p className="text-slate-600 mt-2 text-sm leading-relaxed flex-1">{p.excerpt}</p>
                    <div className="mt-4 inline-flex items-center gap-2 font-semibold text-blue-700 group-hover:gap-3 transition-all">
                      Pročitaj <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
